import { render } from "./note.vue?vue&type=template&id=22229000&ts=true"
import script from "./note.vue?vue&type=script&lang=ts"
export * from "./note.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__